module.exports = __webpack_public_path__ + "img/691-604ce2.png";